/* ============================================================
   LAYDHOME — Theme behaviour
   Sticky nav · mobile sheet · mega-menu · search overlay ·
   AJAX cart drawer · qty steppers · PDP gallery + variants
   ============================================================ */
(function () {
  "use strict";
  var LH = window.LH || {};
  var S = LH.strings || {};
  var money = function (cents) {
    try {
      return new Intl.NumberFormat(LH.locale || "en", { style: "currency", currency: LH.currency || "EUR", minimumFractionDigits: (cents % 100 === 0 ? 0 : 2) }).format(cents / 100);
    } catch (e) { return "€" + (cents / 100).toFixed(2); }
  };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Sticky nav scrolled state ---------- */
  var nav = $(".lh-nav");
  if (nav) {
    var onScroll = function () { nav.setAttribute("data-scrolled", window.scrollY > 8 ? "true" : "false"); };
    onScroll(); window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Background-scroll lock for overlays ---------- */
  var drawerEl = $(".lh-drawer"), searchEl = $(".lh-search"), sheetEl = $(".lh-mobile-sheet");
  function syncScrollLock() {
    var anyOpen = (drawerEl && drawerEl.classList.contains("open")) ||
                  (searchEl && searchEl.classList.contains("open")) ||
                  (sheetEl && sheetEl.classList.contains("open"));
    document.documentElement.classList.toggle("lh-locked", !!anyOpen);
  }

  /* ---------- Mobile sheet ---------- */
  var burger = $(".lh-burger"), sheet = $(".lh-mobile-sheet");
  if (burger && sheet) {
    burger.addEventListener("click", function () {
      var open = sheet.classList.toggle("open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      syncScrollLock();
    });
  }

  /* ---------- Mega-menu (desktop hover) ---------- */
  var navEl = $(".lh-nav"), mega = $(".lh-mega");
  if (navEl && mega) {
    var panels = {};
    $$(".lh-mega-panel", mega).forEach(function (p) { panels[p.getAttribute("data-world")] = p; });
    var showMega = function (slug) {
      mega.classList.add("open");
      Object.keys(panels).forEach(function (k) { panels[k].style.display = k === slug ? "" : "none"; });
    };
    var hideMega = function () { mega.classList.remove("open"); };
    // Close only when leaving the whole header region (nav bar + mega panel),
    // with a short grace delay so moving the cursor down into the panel never closes it.
    var hideTimer;
    var scheduleHide = function () { clearTimeout(hideTimer); hideTimer = setTimeout(hideMega, 160); };
    var cancelHide = function () { clearTimeout(hideTimer); };
    $$(".lh-nav-center .navlink[data-world]").forEach(function (a) {
      a.addEventListener("mouseenter", function () { cancelHide(); showMega(a.getAttribute("data-world")); });
      a.addEventListener("focus", function () { showMega(a.getAttribute("data-world")); });
    });
    navEl.addEventListener("mouseenter", cancelHide);
    navEl.addEventListener("mouseleave", scheduleHide);
    mega.addEventListener("mouseenter", cancelHide);
  }

  /* ---------- Search overlay ---------- */
  var search = $(".lh-search");
  var openSearch = function () { if (search) { search.classList.add("open"); syncScrollLock(); var i = $(".lh-search-input", search); if (i) i.focus(); } };
  var closeSearch = function () { if (search) { search.classList.remove("open"); syncScrollLock(); } };
  $$("[data-open-search]").forEach(function (b) { b.addEventListener("click", openSearch); });
  $$("[data-close-search]").forEach(function (b) { b.addEventListener("click", closeSearch); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeSearch(); closeDrawer(); } });

  /* ---------- Cart drawer ---------- */
  var drawer = $(".lh-drawer"), scrim = $(".lh-scrim");
  var openDrawer = function () { if (drawer) { drawer.classList.add("open"); scrim.classList.add("open"); syncScrollLock(); } };
  var closeDrawer = function () { if (drawer) { drawer.classList.remove("open"); scrim.classList.remove("open"); syncScrollLock(); } };
  $$("[data-open-cart]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); refreshCart(); }); });
  $$("[data-close-cart]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
  if (scrim) scrim.addEventListener("click", closeDrawer);

function renderDrawer(cart) {
  var body = $(".lh-drawer-body"); if (!body) return;
  updateCount(cart.item_count);
    if (!cart.items || cart.items.length === 0) {
    body.innerHTML = '<div class="lh-drawer-empty">' +
      '<p class="body t-muted">' + (S.cartEmpty || "Uw winkelwagen is leeg.") + '</p>' +
      '<a class="btn btn-secondary" href="' + (LH.routes.all_products || "/collections/all") + '">' + (S.cartBrowse || "Browse the rooms") + '</a></div>';
    return;
  }
  var items = cart.items.map(function (i) {
    var img = i.image ? '<img class="lh-line-img ph-img" src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") + '" alt="' + i.product_title + '">' :
      '<div class="lh-line-img ph"><span class="ph-inner"><span class="ph-label">' + i.product_title.toLowerCase() + '</span></span></div>';
    var variant = (i.variant_title && i.variant_title !== "Default Title") ? '<p class="micro mono t-muted" style="margin-top:4px">' + i.variant_title + '</p>' : "";
    return '<div class="lh-line" data-key="' + i.key + '">' + img +
      '<div style="flex:1;min-width:0">' +
        '<div class="row" style="justify-content:space-between;gap:10px;align-items:baseline">' +
          '<a class="h3" style="font-size:18px" href="' + i.url + '">' + i.product_title + '</a>' +
          '<span class="mono" style="font-size:15px">' + money(i.final_line_price) + '</span></div>' +
        '<p class="caption" style="margin-top:2px">' + (i.product_type || "") + '</p>' + variant +
        '<div class="row" style="justify-content:space-between;margin-top:12px">' +
          '<div class="lh-qty sm" data-key="' + i.key + '">' +
            '<button data-qty="-1" aria-label="' + (S.decrease || "Decrease") + '">–</button>' +
            '<span class="lh-qty-val">' + i.quantity + '</span>' +
            '<button data-qty="1" aria-label="' + (S.increase || "Increase") + '">+</button></div>' +
          '<button class="lh-line-remove" data-remove="' + i.key + '" aria-label="' + (S.remove || "Remove") + '">' + (S.remove || "Remove") + '</button>' +
        '</div></div></div>';
  }).join("");
  body.innerHTML =
    '<div class="lh-drawer-items">' + items + '</div>' +
    '<div class="lh-drawer-foot">' +
      '<div class="row" style="justify-content:space-between;margin-bottom:6px">' +
        '<span class="body" style="font-weight:600">' + (S.subtotal || "Subtotal") + '</span>' +
        '<span class="mono" style="font-size:18px;font-weight:600">' + money(cart.total_price) + '</span></div>' +
      '<p class="micro t-muted" style="margin-bottom:16px">' + (S.shippingNote || "Shipping and any duties are calculated at checkout. No surprises.") + '</p>' +
      '<a class="btn btn-primary btn-block btn-lg" href="/checkout">' + (S.checkout || "Checkout") + '</a>' +
            '<div class="row" style="justify-content:center;gap:22px;margin-top:14px">' +
        '<a class="link" style="font-size:13px" href="' + (LH.routes.cart || "/cart") + '">' + (S.viewBag || "View full bag") + '</a>' +
        '<button type="button" class="link" style="font-family:inherit;font-size:13px;background:none;border:none;cursor:pointer" data-drawer-close>' + (S.continueShopping || "Verder winkelen") + '</button>' +      '</div>' +
        '</div>';

  var contBtn = body.querySelector('[data-drawer-close]');
  if (contBtn) contBtn.addEventListener('click', closeDrawer);
}

  function updateCount(n) {
    $$(".lh-bag-badge").forEach(function (b) { b.textContent = n; b.style.display = n > 0 ? "" : "none"; });
  }

  function refreshCart() {
    fetch(LH.routes.cart_url ? LH.routes.cart_url + ".js" : "/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); }).then(renderDrawer).catch(function () {});
  }

  function changeQty(key, qty) {
    fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (cart) { renderDrawer(cart); }).catch(function () {});
  }

  if (drawer) {
    drawer.addEventListener("click", function (e) {
      var rem = e.target.closest("[data-remove]");
      if (rem) { changeQty(rem.getAttribute("data-remove"), 0); return; }
      var step = e.target.closest(".lh-qty [data-qty]");
      if (step) {
        var box = step.closest(".lh-qty"); var key = box.getAttribute("data-key");
        var val = parseInt($(".lh-qty-val", box).textContent, 10) + parseInt(step.getAttribute("data-qty"), 10);
        changeQty(key, Math.max(0, val));
      }
    });
  }

  /* ---------- Add to cart (AJAX) ---------- */
  $$(".js-product-form").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = $("[type=submit]", form); if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = (S.adding || "Adding…"); }
        fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCart(); openDrawer(); })
        .catch(function () {})
        .finally(function () { if (btn) { btn.disabled = false; if (btn.dataset.label) btn.textContent = btn.dataset.label; } });
    });
  });

  /* ---------- Generic qty steppers (PDP) ---------- */
  $$(".lh-qty[data-input]").forEach(function (box) {
    var input = $("#" + box.getAttribute("data-input"));
    var valEl = $(".lh-qty-val", box);
    box.addEventListener("click", function (e) {
      var b = e.target.closest("[data-qty]"); if (!b || !input) return;
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute("data-qty"), 10));
      input.value = v; if (valEl) valEl.textContent = v;
    });
  });

  /* ---------- PDP gallery ---------- */
  $$("[data-gallery]").forEach(function (g) {
    var thumbs = $$(".lh-thumb", g), slides = $$(".lh-gallery-slide", g);
    thumbs.forEach(function (t, i) {
      t.addEventListener("click", function () {
        thumbs.forEach(function (x) { x.classList.remove("active"); });
        slides.forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active"); if (slides[i]) slides[i].classList.add("active");
      });
    });
  });

  /* ---------- PDP variant selection ---------- */
  $$("[data-variant-picker]").forEach(function (picker) {
    var form = picker.closest("form") || document;
    var idInput = $("[name=id]", form);
    var priceEl = $("[data-price]", form);
    var btn = $("[data-add-label]", form);
    var data = {};
    try { data = JSON.parse($("[data-variant-json]", picker).textContent); } catch (e) {}
    $$(".lh-variant", picker).forEach(function (b) {
      b.addEventListener("click", function () {
        $$(".lh-variant", picker).forEach(function (x) { x.classList.remove("active"); });
        b.classList.add("active");
        var id = b.getAttribute("data-variant-id");
        if (idInput) idInput.value = id;
        var v = data[id];
        if (v && priceEl) priceEl.textContent = money(v.price);
       if (v && btn) btn.textContent = (S.addToBag || "Add to bag") + " · " + money(v.price);
      });
    });
  });

  /* ---------- Scroll reveal (premium staggered entrance) ---------- */
  var reveals = $$("[data-reveal]");
  if (reveals.length) {
    if ("IntersectionObserver" in window) {
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("is-visible"); revealIO.unobserve(e.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
      reveals.forEach(function (el) { revealIO.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add("is-visible"); });
    }
  }

  /* ---------- Hero parallax + slow zoom ---------- */
  var heroSection = $(".lh-hero");
  var heroImg = heroSection ? $(".lh-hero-img .ph-img", heroSection) : null;
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (heroSection && heroImg && !reduceMotion) {
    var hpTicking = false;
    var heroParallax = function () {
      var rect = heroSection.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        var shift = Math.max(0, -rect.top) * 0.18;
        heroImg.style.transform = "scale(1.12) translate3d(0," + shift.toFixed(1) + "px,0)";
      }
      hpTicking = false;
    };
    window.addEventListener("scroll", function () {
      if (!hpTicking) { hpTicking = true; window.requestAnimationFrame(heroParallax); }
    }, { passive: true });
    heroParallax();
  }

  /* initial cart count sync */
  refreshCart();
})();

/* ---------- Announcement bar rotation (appended) ---------- */
(function () {
  "use strict";
  var bar = document.querySelector("[data-announcement]");
  if (!bar) { return; }
  var msgs = Array.prototype.slice.call(bar.querySelectorAll(".lh-anno-msg"));
  if (msgs.length < 1) { return; }
  var i = 0, k;
  for (k = 0; k < msgs.length; k++) { if (msgs[k].classList.contains("active")) { i = k; break; } }
  msgs[i].classList.add("active");
  function show(n) {
    i = ((n % msgs.length) + msgs.length) % msgs.length;
    for (var j = 0; j < msgs.length; j++) { msgs[j].classList.toggle("active", j === i); }
  }
  var prev = bar.querySelector("[data-anno-prev]"), next = bar.querySelector("[data-anno-next]");
  var secs = parseInt(bar.getAttribute("data-rotate"), 10);
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var timer = null;
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  function start() { if (!reduce && secs && msgs.length > 1 && !timer) { timer = setInterval(function () { show(i + 1); }, secs * 1000); } }
  function restart() { stop(); start(); }
  if (prev) { prev.addEventListener("click", function () { show(i - 1); restart(); }); }
  if (next) { next.addEventListener("click", function () { show(i + 1); restart(); }); }
  // Pause on hover / keyboard focus so motion can be stopped (WCAG 2.2.2) and a focused link is never hidden.
  bar.addEventListener("mouseenter", stop);
  bar.addEventListener("mouseleave", start);
  bar.addEventListener("focusin", stop);
  bar.addEventListener("focusout", start);
  start();
})();
